import React from "react";
import { Table, Tag, Row, Col } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const ControlsAssignmentTable = ({ assignmentsControlsToAssets, assets }) => {
  // Función para generar los datos de la tabla agrupados por Activo y Dependencia
  const generateTableData = () => {
    const data = [];

    // Recorrer todos los activos
    assets.forEach((asset) => {
      // Recorrer todas las dependencias del activo
      asset.dependencies.forEach((dependency) => {
        // Obtener los controles asignados para esta dependencia
        const controls = assignmentsControlsToAssets[asset.key]?.[dependency.key] || {};

        // Obtener los controles iniciales (desde el backend) de la dependencia
        const initialControls = dependency.controls.reduce((acc, control) => {
          acc[control.code] = control.flag;
          return acc;
        }, {});

        // Filtrar los controles que han cambiado
        const changedControls = Object.keys(controls)
          .filter((controlCode) => controls[controlCode] !== initialControls[controlCode])
          .map((controlCode) => {
            const control = dependency.controls.find((c) => c.code === controlCode);
            return {
              title: control.title,
              status: controls[controlCode] ? "Activo" : "Inactivo",
            };
          });

        // Si hay controles modificados, agregar una fila a la tabla
        if (changedControls.length > 0) {
          data.push({
            key: `${asset.key}-${dependency.key}`,
            asset: asset.title,
            dependency: dependency.name,
            controls: changedControls,
          });
        }
      });
    });

    return data;
  };

  // Columnas de la tabla
  const columns = [
    {
      title: "Activos",
      dataIndex: "asset",
      key: "asset",
      sorter: (a, b) => a.asset.localeCompare(b.asset),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      align: 'center',
      width: '10%',
    },
    {
      title: "Dependencia",
      dataIndex: "dependency",
      key: "dependency",
      sorter: (a, b) => a.dependency.localeCompare(b.dependency),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      align: 'center',
      width: '15%',
    },
    {
      title: "Controles Asignados",
      dataIndex: "controls",
      key: "controls",
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } }),
      width: '75%',
      render: (controls) => (
        <Row gutter={[8, 8]} style={{ marginLeft: 0, marginRight: 0 }}>
          {controls.map((control, index) => (
            <Col key={index} span={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "4px 8px",
                  backgroundColor: control.status === "Activo" ? "#f6ffed" : "#fff2f0",
                  borderRadius: "4px",
                  border: `1px solid ${control.status === "Activo" ? "#b7eb8f" : "#ffccc7"}`,
                }}
              >
                {control.status === "Activo" ? (
                  <>
                    <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    <span style={{ fontWeight: "bold", color: "#52c41a" }}>Asignado</span>
                  </>
                ) : (
                  <>
                    <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
                    <span style={{ fontWeight: "bold", color: "#ff4d4f" }}>Desasignado</span>
                  </>
                  )}
                <span>{control.title}</span>
              </div>
            </Col>
          ))}
        </Row>
      ),
    },
  ];

  // Datos de la tabla (agrupados por Activo y Dependencia)
  const tableData = generateTableData();

  return (
    <Col span={24}>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        scroll={{ y: 450 }}
        style={{ minHeight: 224 }}
        rowKey="id"  
      />
    </Col>
  );
};

export default ControlsAssignmentTable;